<accredible-base-header *transloco="let t; read: 'credential_net.header'">

  <div identitySection>
    <a class="default-logo"
      href="https://www.accredible.com/?utm_source=credential&utm_medium=referral&utm_campaign=navbar_logo_link"
      target="_blank">
      <img src="assets/themes/credential.net/images/accredible_credential_net_logo.svg"
        [alt]="t('credential_net_logo')">
    </a>
  </div>

  <div navigationSection>
    <sl-header-menu></sl-header-menu>
  </div>
</accredible-base-header>
